// Exports
export default {
	"batchLoadingSkeleton": "batchLoadingSkeleton_5fFO6"
};
